// redux/files/files.reducer.js
const empty = {
  key: null,
  project: [],
  workspace: [],
  projectLoading: true,
  workspaceLoading: false,
  projectError: "",
  workspaceError: "",
};
export const setFiles = (payload) => ({ type: "FILES_SET", payload });
export default function filesReducer(state = empty, { type, payload }) {
  if (type !== "FILES_SET") return state;
  if (payload.reset) return { ...empty, ...payload };
  return state.key === payload.key ? { ...state, ...payload } : state;
}
